import React, { Suspense, lazy } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { UIProvider } from './context/UIContext'
import { ThemeProvider } from './context/ThemeContext'
import UserProvider from './context/UserContext'
import SubscriptionProvider from './context/SubscriptionContext'
import ChatProvider from './context/ChatContext'
import ErrorBoundary from './components/ErrorBoundary'
import Loader from './components/loader/Loader'
const AppRoutes = lazy(() => import('./routes/AppRoutes'))

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 10 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: false,
    },
  },
})

// Define the App component
const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <UIProvider>
            <UserProvider>
              <SubscriptionProvider>
                <ChatProvider>
                  <BrowserRouter>
                    <Suspense fallback={<Loader />}>
                      <AppRoutes />
                    </Suspense>
                  </BrowserRouter>
                </ChatProvider>
              </SubscriptionProvider>
            </UserProvider>
          </UIProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  )
}

export default App
